import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useForm, FormProvider } from 'react-hook-form';
import GovButton from '../Buttons/GovButton';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@mui/material';
import * as yup from 'yup';
import GovWrapper from '../GovWrapper';
import { TextFieldElement } from 'react-hook-form-mui';

export default function AddQuestionCategoryModal(props) {
  const { open, handleClose, submitForm } = props;

  const formValidationSchema = yup.object().shape({
    description: yup.string().required('To πεδίο είναι υποχρεωτικό'),
  });

  const methods = useForm({
    resolver: yupResolver(formValidationSchema),
  });

  // Handle form submission
  const onSubmit = methods.handleSubmit((data, event) => {
    event.preventDefault();
    submitForm(data);
    methods.reset();
  });

  return (
    <FormProvider {...methods}>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <form onSubmit={onSubmit}>
          <DialogContent>
            <GovWrapper label={'Περιγραφή'} width={'100%'} id="description">
              <TextFieldElement id="description" name="description" fullWidth />
            </GovWrapper>
          </DialogContent>
          <DialogActions sx={{ margin: 2 }}>
            <Box sx={{ marginRight: 2 }}>
              <GovButton
                ariaLabel={'cancel-admin-addition'}
                type={'button'}
                background={'white'}
                hoverBackground={'white'}
                onClick={handleClose}
                color={'#003476'}
                borderColor={'#003476'}
                variant={'outlined'}
              >
                Ακύρωση
              </GovButton>
            </Box>
            <GovButton
              ariaLabel={'submit-admin-addition'}
              type={'submit'}
              background={'#003476'}
              borderColor={'#003476'}
              hoverBackground={'#02234e'}
              color={'white'}
              variant={'contained'}
            >
              Υποβολή
            </GovButton>
          </DialogActions>
        </form>
      </Dialog>
    </FormProvider>
  );
}
